import { render, staticRenderFns } from "./TrademarkSearchDatabaseForm.vue?vue&type=template&id=0930677a&"
import script from "./TrademarkSearchDatabaseForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchDatabaseForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchDatabaseForm.vue?vue&type=style&index=0&id=0930677a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports